/**
 * Mensaje que el back devuelve al rechazar una generación de archivos SRT por
 * una regla de negocio (400/409: la tanda mezcla aseguradoras, la aseguradora
 * no tiene código, etc.). Esos mensajes están pensados para el usuario, así que
 * se muestran tal cual en vez del error genérico.
 *
 * Devuelve `null` si el error no es un 4xx o no trae `data.message` como texto:
 * un 5xx puede traer un mensaje técnico que no corresponde mostrar, y el 401 ya
 * lo resuelve el reintento con refresh (o el logout) del baseQuery.
 */
export const obtenerMensajeRechazoGeneracion = (error: unknown): string | null => {
    const errorHttp = error as {
        status?: unknown;
        data?: { statusCode?: unknown; message?: unknown };
    };
    const status =
        typeof errorHttp?.status === 'number'
            ? errorHttp.status
            : Number(errorHttp?.data?.statusCode);

    if (!(status >= 400 && status < 500) || status === 401) return null;

    const mensaje = errorHttp?.data?.message;
    if (typeof mensaje !== 'string' || mensaje.trim() === '') return null;

    return mensaje.trim();
};

/** El 500 genérico del back al fallar la generación: se traduce a un aviso propio. */
export const esErrorGenericoGeneracion = (error: unknown): boolean => {
    const errorHttp = error as { data?: { statusCode?: unknown; message?: unknown } };
    return (
        errorHttp?.data?.statusCode === 500 &&
        errorHttp?.data?.message === 'Error al generar archivos.'
    );
};
